import gsap from 'imports/gsap'
import browser from 'imports/browser-detect'
import stickCommon from 'site/stick.common'
//import AOS from 'imports/aos'
let stickSite = {
    browser:browser(),
    init: function () {
        //add browser name
        if (stickSite.browser && stickSite.browser.name) {
            $('body').addClass("browser-" + stickSite.browser.name)
        }

        //mobile stuff
        $('.ui-link').removeClass('ui-link')

        //disable img drag
        $('img').on('dragstart', function (event) {
            event.preventDefault()
        })
        if (stickSite.browser && stickSite.browser.mobile) {
            $('body').addClass("device-mobile")
        } else {
            $('body').addClass("device-notmobile")
        }

        //analytics
        stickCommon.scAddAnalyticsEventHandle('body')

        //orientation change & resize
        $(window).on("orientationchange",function(){
            stickSite.siteResize()
        })
        $(window).on("resize",function(){
            stickSite.siteResize()
        })
        stickSite.siteResize()
        window.dispatchEvent(new Event('resize'))

        $('#container').css('opacity',1)


        $('.order-open-hook').on('click', stickSite.orderOpen)
        $('.order-close-hook').on('click', stickSite.orderClose)
        $(document).on('keydown', function(event) {
            stickSite.orderClose();
        });
    },
    orderOpen() {
        $('.bugs-hider').hide()
        let order = $(this).attr('data-order')
        $('#bugs-'+order).show()
        $('#order').addClass('open');
    },
    orderClose() {
        $('#order').removeClass('open');
    },
    siteOrientationChange() {
        setTimeout(function() {
            let isPortrait = true
            if ($('body').hasClass('device-notmobile')) {
                isPortrait = true
            } else {
                isPortrait = ($(window).width() < $(window).height())
            }
            if (isPortrait) {
                $('#rotate-holder').hide()
            } else {
                $('#rotate-holder').show()
            }
            //if( (window.orientation === 90 && $( window ).width() < 780) || (window.orientation === -90 && $( window ).width() < 780) ) // Landscape {
        },100)
    },
    siteResize: function () {
        stickSite.siteOrientationChange()

        //
        let scale = 1
        let w = $(window).width()
        let h = $(window).height()


        let centerContentWidth = 1400
        let centerContentHeight = 1100
        let centerContentRatio = centerContentWidth/centerContentHeight

        let hpad = 350
        if ( h < centerContentHeight + hpad) {
            scale = h / ( centerContentHeight + hpad)
        } else if (w < centerContentWidth) {
            scale = 0.95
        }
        //override for super mobile
        if (w < 600) {
            scale = 0.95
        }
        //gsap.set('.center-content', {scale:scale})

    }
}
export default stickSite
